import { Module } from 'vuex';
import { RootStateI } from '../state';
import { state, FeedbackStateI } from './state';
import { mutations } from './mutations';
import { actions } from './actions';

const feedback: Module<FeedbackStateI, RootStateI> = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default feedback;
